<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control"></hb-df-control-label>
    <button class="add-btn-alt" *ngIf="showButton()" (click)="onClickEvent()">
      <i class="fa fa-edit"></i>
    </button>
  </div>
  <div class="col-md-12">
    <p-listbox
      class="form-control hb-listbox"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [options]="control.options"
      [formControlName]="control.key"
      [listStyle]="{ 'max-height': '90px' }"
      ngDefaultControl
    >
    </p-listbox>
  </div>
</div>
